/**
 * save-blob.ts
 * Hands a Blob to the phone as a file (download/preview) through a temporary
 * same-origin object URL — the certificate download and "Mis documentos"
 * files both go through here. An <a download> rather than window.open(): it
 * is not caught by popup blockers after an await.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Not right after click(): mobile browsers (iOS PWAs above all) may start
  // the download/preview later, and a revoked URL makes it fail.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
